module.exports = __webpack_public_path__ + "img/ai-script.b0368fc3.svg";